// Renders Apply Filters button from customFilterDialogFooter.
import React from "react";
import styled from "styled-components";
import { Box, Button } from "@mui/material";
import { spacing } from "@mui/system";

const Wrapper = styled(Box)(
  spacing,
  (props) => `
  min-width: ${props["min-width"] || "320px"}
`
);

function FilterDialogFooter({ onClick, minWidth }) {
  return (
    <Wrapper
      mt={6}
      min-width={minWidth}
      display="flex"
      justifyContent="flex-end"
    >
      <Button
        variant="contained"
        size="small"
        color="primary"
        aria-haspopup="true"
        data-testid="apply-filters"
        onClick={onClick}
      >
        Apply Filters
      </Button>
    </Wrapper>
  );
}

export default FilterDialogFooter;
